import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Industry {
  _id: string;
  name: string;
  [key: string]: any;
}

interface IndustryState {
  industries: Industry[];
}

const initialState: IndustryState = {
  industries: [],
};

const industrySlice = createSlice({
  name: "industries",
  initialState,
  reducers: {
    setAllIndustries: (state, action: PayloadAction<Industry[]>) => {
      state.industries = action.payload;
    },
  },
});

export const { setAllIndustries } = industrySlice.actions;

export default industrySlice.reducer;
